/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Duration_Too_LongInputs */

const en_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event duration cannot exceed 30 seconds for recording.`)
};

const fr_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La durée de l'événement ne peut pas dépasser 30 secondes pour l'enregistrement.`)
};

const de_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisdauer darf für die Aufzeichnung 30 Sekunden nicht überschreiten.`)
};

const it_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La durata dell'evento non può superare i 30 secondi per la registrazione.`)
};

const ru_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность записи события не должна превышать 30 секунд.`)
};

const es_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La duración del evento no puede exceder los 30 segundos para la grabación.`)
};

const zh_cn2_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录制事件的持续时间不能超过 30 秒。`)
};

const ja_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`録画のイベント継続時間は 30 秒を超えることはできません。`)
};

const hi_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग के लिए इवेंट की अवधि 30 सेकंड से अधिक नहीं हो सकती।`)
};

const pt_pt2_audio_recorder_duration_too_long = /** @type {(inputs: Audio_Recorder_Duration_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A duração do evento não pode exceder 30 segundos para gravação.`)
};

/**
* | output |
* | --- |
* | "Event duration cannot exceed 30 seconds for recording." |
*
* @param {Audio_Recorder_Duration_Too_LongInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_duration_too_long = /** @type {((inputs?: Audio_Recorder_Duration_Too_LongInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Duration_Too_LongInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_duration_too_long(inputs)
	if (locale === "de") return de_audio_recorder_duration_too_long(inputs)
	if (locale === "it") return it_audio_recorder_duration_too_long(inputs)
	if (locale === "ru") return ru_audio_recorder_duration_too_long(inputs)
	if (locale === "es") return es_audio_recorder_duration_too_long(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_duration_too_long(inputs)
	if (locale === "ja") return ja_audio_recorder_duration_too_long(inputs)
	if (locale === "hi") return hi_audio_recorder_duration_too_long(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_duration_too_long(inputs)
	return en_audio_recorder_duration_too_long(inputs)
});